/*
 *  I06SEPHYDI18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-31 10:46:15 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I06SEPHYD_SECTION_0_TITLE: "Calculez les dimensions d'un séparateur hydraulique",
  I06SEPHYD_in_index_puissanceOrQ: '', //do not remove, empty for segment purpose
  I06SEPHYD_in_index_puissanceOrQ_mail: 'Type',
  I06SEPHYD_in_index_puissanceOrQ_0: 'Puissance',
  I06SEPHYD_in_index_puissanceOrQ_1: 'Débit',
  I06SEPHYD_in_puissQ: 'Puissance',
  I06SEPHYD_in_deltaT: 'Delta Température',
  I06SEPHYD_in_debit: 'Débit',
  I06SEPHYD_in_velocite: 'Vélocité primaire',
  I06SEPHYD_SECTION_1_TITLE: '',
  I06SEPHYD_Secondaire: 'Circuit secondaire',
  I06SEPHYD_Primaire: 'Circuit Primaire'
}
